import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { AssignEmployeeService, Employee, EmployeeDTO } from '../../models/employee.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'employees/';
  url = environment.service_1 + 'all-employees/';
  urlAdd = environment.service_1 + 'assign-employee-service/';
  urlUpdateAdd = environment.service_1 + 'update-assign-employee-service/';
  urlDelete = environment.service_1 + 'delete-assign-employee-service/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedEmployee = new BehaviorSubject<Employee | null>(null);
  selectedEmployee$ = this.selectedEmployee.asObservable();

  private employees = new BehaviorSubject<Employee[]>([]);
  employees$ = this.employees.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setEmployee(employee: Employee) {
    this.selectedEmployee.next(employee);
  }

  setEmployees(employees: Employee[]) {
    this.employees.next(employees);
  }

  removeEmployeeSelected() {
    this.selectedEmployee.next(null);
  }

  createEmployee(employee: EmployeeDTO) {
    return this.http.post<Employee>(this.urlPath, employee).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateEmployee(id: number, employee: EmployeeDTO & { id: number }) {
    return this.http.put<Employee>(this.urlPath + id + '/', employee).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  addEmployee(employee: AssignEmployeeService) {
    return this.http.post(this.urlAdd, employee).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateAddEmployee(id: number, employee: AssignEmployeeService & { id: number }) {
    return this.http.put(this.urlUpdateAdd + id + '/', employee).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getEmployee(query: QueryGet): Observable<Pagination<Employee[]>> {
    return this.requestService.get<Employee[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  deleteAssignEmploye(id: number): Observable<void> {
    return this.http.delete<void>(this.urlDelete + id + '/');
  }

  getEmployees(): Observable<Employee[]> {
    return this.http.get<Employee[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionEmployee(component: Employee[]): OptionSelect[] {
    return component.map((item: Employee) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
